import React from 'react';

import WrappedBase from './WrappedBase';
import StarRating from '../components/StarRating';

export default class StarRatingWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <StarRating {...this.props} />
      </WrappedBase>
    );
  }
}
